import dayjs from 'dayjs';

/**
 * 완전면책 가격 A/B 실험 식별자.
 *
 * 실제 가격은 서버 상수(`@orcar/common`의 `SUPER_INSURANCE_DAILY_FEE`)에서 바꾼다.
 * 가격을 변경·배포할 때 아래 `version`/`appliedAt`만 함께 올리면 된다.
 * 라벨을 놓쳐도 이벤트의 `insurance_price_per_day`/`insurance_price_total`(실제
 * 노출가)로 가격 구간을 사후 분리할 수 있으므로 라벨은 편의값, 실제 금액이 안전망이다.
 */
export const SUPER_INSURANCE_EXPERIMENT = {
  id: 'super_insurance_price_test_01',
  version: 'V8',
  appliedAt: '2026-08-24',
} as const;

/**
 * 기대이익 계산 기본값(사고율·건당 평균 수리비).
 * 실제 집계·계산은 분석 단계(Mixpanel/시트)에서 수행하며, 값 조정이 잦으므로 분리한다.
 */
export const INSURANCE_EXPECTED_PROFIT = {
  accidentRate: 0.02,
  avgRepairCost: 500_000,
} as const;

/**
 * 대여일수(캘린더 일수차 + 1). 서버 `calculateDays`(총액 = 1일요금 × 일수)와 동일 기준.
 * 값이 유효하지 않으면 `undefined`.
 */
export const getRentalDays = (
  pickUpAt?: string | Date | null,
  dropOffAt?: string | Date | null,
): number | undefined => {
  if (!pickUpAt || !dropOffAt) return undefined;
  const days =
    dayjs(dropOffAt)
      .startOf('day')
      .diff(dayjs(pickUpAt).startOf('day'), 'day') + 1;
  return days > 0 ? days : undefined;
};

/**
 * 총 특약금액을 1일 단가로 환산한 관측값. 일수가 없으면 `undefined`.
 * (총액 = 1일요금 × 일수 이므로 per_day는 실제 가격표 값과 일치한다.)
 */
export const getInsurancePerDay = (
  total?: number | null,
  days?: number,
): number | undefined => {
  if (!total || !days || days <= 0) return undefined;
  return Math.round(total / days);
};
